import { render, staticRenderFns } from "./MinionSaveModal.vue?vue&type=template&id=3ea195d4&scoped=true&"
import script from "./MinionSaveModal.vue?vue&type=script&lang=js&"
export * from "./MinionSaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea195d4",
  null
  
)

export default component.exports